import React, { useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import SEO from '../components/SEO';
import { ArrowLeft } from 'lucide-react';

const CGU = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{ backgroundColor: 'var(--bg-color)', minHeight: '100vh', color: 'var(--text-primary)', padding: '2rem 1rem' }}>
      <SEO title="CGU | Masse-terclass" />
      <div style={{ maxWidth: '800px', margin: '0 auto', backgroundColor: 'var(--bg-card)', padding: '2rem', borderRadius: '12px', border: '1px solid var(--border-color)' }}>
        
        <button className="btn btn-outline" onClick={() => { window.scrollTo(0,0); navigate('/'); }} style={{ marginBottom: '2rem', display: 'inline-flex', alignItems: 'center', gap: '0.5rem' }}>
          <ArrowLeft size={18} /> Retour
        </button>

        <h1 style={{ color: 'var(--primary-color)', marginBottom: '2rem', fontSize: '2.5rem' }}>Conditions Générales d'Utilisation (CGU)</h1>
        
        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--text-primary)' }}>1. Objet</h2>
          <p style={{ lineHeight: '1.6', color: 'var(--text-secondary)' }}>
            Les présentes Conditions Générales d'Utilisation ont pour objet d'encadrer l'accès et l'utilisation du site <strong>Masse-terclass</strong>. La création d'un compte sur le site implique l'acceptation sans réserve des présentes CGU.
          </p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--text-primary)' }}>2. Avertissement médical et responsabilité</h2>
          <p style={{ lineHeight: '1.6', color: 'var(--text-secondary)' }}>
            Masse-terclass est un outil de suivi d'entraînement sportif. Les programmes, conseils et statistiques générés par l'application (y compris par le "Coach IA") sont fournis à titre purement indicatif.<br /><br />
            <strong>L'éditeur du site ne saurait être tenu responsable d'une quelconque blessure, problème de santé ou dommage matériel survenu lors de l'exécution des exercices.</strong> Il est fortement recommandé de consulter un médecin avant d'entreprendre un programme sportif et de se faire encadrer par un professionnel diplômé pour l'apprentissage des mouvements.
          </p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--text-primary)' }}>3. Comportement sur le Forum et fonctionnalités sociales</h2>
          <p style={{ lineHeight: '1.6', color: 'var(--text-secondary)' }}>
            En utilisant le Forum et les fonctionnalités de partage de Masse-terclass, l'utilisateur s'engage à :
          </p>
          <ul style={{ lineHeight: '1.6', color: 'var(--text-secondary)', marginLeft: '1.5rem', marginTop: '0.5rem' }}>
            <li>Faire preuve de respect et de courtoisie envers les autres membres.</li>
            <li>Ne pas publier de contenus injurieux, diffamatoires, racistes, ou contraires à la loi.</li>
            <li>Ne pas faire de publicité non sollicitée (spam).</li>
          </ul>
          <p style={{ lineHeight: '1.6', color: 'var(--text-secondary)', marginTop: '0.5rem' }}>
            L'équipe de Masse-terclass se réserve le droit de supprimer tout message ne respectant pas ces règles et de bannir définitivement le compte de l'utilisateur fautif, sans préavis.
          </p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--text-primary)' }}>4. Compte utilisateur</h2>
          <p style={{ lineHeight: '1.6', color: 'var(--text-secondary)' }}>
            L'utilisateur est responsable de la confidentialité de ses identifiants de connexion. Toute action effectuée depuis son compte est réputée avoir été réalisée par lui-même. En cas de perte ou de vol de ses identifiants, l'utilisateur doit immédiatement le signaler via la page de <Link to="/contact" style={{ color: 'var(--primary-color)' }}>Contact</Link>.
          </p>
        </section>
        
        <section>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--text-primary)' }}>5. Modification des CGU</h2>
          <p style={{ lineHeight: '1.6', color: 'var(--text-secondary)' }}>
            Masse-terclass se réserve le droit de modifier les présentes CGU à tout moment. Les utilisateurs seront informés des changements majeurs. En continuant d'utiliser le site après modification, l'utilisateur accepte les nouvelles CGU.
          </p>
        </section>

      </div>
    </div>
  );
};

export default CGU;
